module.exports = __webpack_public_path__ + "img/dp-sy-lm4.5c8b673b.png";